import { Box } from "theme-ui"
import { useTranslation } from "react-i18next"
import "./style/style.css"

interface ITableModel {
 tableName?: string
 tableColumns?: string[]
 data?: any[]
 spacingTop?: string
}
export const TableModel = ({ tableName, tableColumns, data, spacingTop }: ITableModel) => {
 // language translator
 const { t } = useTranslation("translation")
 return (
  <div className={`${spacingTop ? spacingTop : ""}`}>
   <Box bg="sky">
    <p className="text-left p-3">{tableName}</p>
   </Box>
   {data?.length !== 0 ? (
    <Box bg="highlight" color="bg-gray">
     <table className="w-full text-xs px-4 py-3 sm:px-4">
      <thead className="rounded-t-lg">
       <tr className="flex justify-between gap-2 text-right border-b border-light-gray">
        {tableColumns &&
         tableColumns?.map((colName, index) => (
          <div
           // bg={``}
           key={index}
           className={`${
            index === 0 ? "w-[33%]" : tableColumns?.length < 5 ? "w-[23%]" : "w-[20%]"
           } whitespace-nowrap`}
          >
           <th title="Ranking" className="p-4 text-left" key={index}>
            {colName}
           </th>
          </div>
         ))}
       </tr>
      </thead>
      <tbody className="">
       {data &&
        data.map((row, index) => (
         <tr className={`flex justify-between text-right ${index % 2 === 0 ? "" : ""}`} key={index}>
          {" "}
          {Object.entries(row).map(([key, value], cellIndex) => (
           <Box
            key={key}
            bg={`${index % 2 === 0 ? "highlight2" : "gray2"}`}
            className={`${cellIndex === 0 ? "w-[35%]" : "w-[20%]"} w-full`}
           >
            <td
             key={cellIndex}
             className={`px-3 py-2 text-left w-[15%] border-light-gray whitespace-nowrap ${
              cellIndex === 0 ? "border border-x-0 border-t-0 " : "border border-r-0 border-t-0"
             }`}
            >
             <div
              className={`${
               cellIndex === 0 ? "text-left min-w-[160px]" : "min-w-[100px] text-center"
              } `}
             >
              {value as React.ReactNode}
             </div>
            </td>
           </Box>
          ))}
         </tr>
        ))}
      </tbody>
     </table>
    </Box>
   ) : (
    <div className="w-full mx-auto text-center">
     <div className="text-2xl text-dark-black pt-5 pb-2">{t("noDataFound")}</div>
    </div>
   )}
  </div>
 )
}
